<template lang="html">
  <section class="productos-list-section">
    <div class="container mvl">
      <template v-if="!isProduct">
        <h3 class="title -main" v-html="$t('productos_list.title')"></h3>

        <h2 class="title pequeño">{{ $t("productos_list.subtitle") }}</h2>
      </template>

      <div class="scroll-mvl">
        <div class="productos-list row-center ais">
          <article :class="['producto', producto.id]" v-for="(producto, key) in productos" @mouseover="togif(producto.id)" @mouseleave="toJPG(producto.id)" :active="active == producto.id">
            <button class="enlace-cover" @click="setActive(producto.id)"></button>

            <div class="contenedor-imagen">
              <img :src="
                  '/static/img/gifs-productos/' +
                    producto.id +
                    '.' +
                    gif[producto.id]
                " alt="gif producto" />
            </div>

            <h4 v-html="producto.nombre"></h4>
          </article>
        </div>
      </div>
    </div>

    <section class="intro-software-gestion">
      <div class="box container">
        <div class="producto-desc row-between container" :active="active == 'empresa'">
          <div class="texto">
            <h2 class="title" v-html="
                $t('productos_list.productos.plataforma_e_learning.title')
              "></h2>
            <p v-html="
                $t('productos_list.productos.plataforma_e_learning.description')
              "></p>

            <router-link class="btn-rounded-blue" :to="
                `${$t('enlaces.servicios')}/${$t(
                  'enlaces.plataforma_e_learning'
                )}`
              ">{{ $t("moreInfo") }}</router-link>
          </div>

          <img src="/static/img/productos/plataforma-elearning.jpg" alt="plataforma e-learning" />
        </div>
        <div class="producto-desc row-between container" :active="active == 'firma'">
          <div class="texto">
            <h2 class="title" v-html="
                      $t('productos_list.productos.plataforma_e_learning.title')
                    "></h2>
            <p v-html="
                      $t(
                        'productos_list.productos.plataforma_e_learning.description'
                      )
                    "></p>

            <router-link class="btn-rounded-blue" :to="
                      `${$t('enlaces.servicios')}/${$t(
                        'enlaces.plataforma_e_learning'
                      )}`
                    ">{{ $t("moreInfo") }}</router-link>
          </div>

          <img src="/static/img/productos/e-learning.jpg" alt="firma digitale" />
        </div>
        <div class="producto-desc row-between container" :active="active == 'orientacion'">
          <div class="texto">
            <h2 class="title" v-html="
                $t('productos_list.productos.orientacion_profesional.title')
              "></h2>
            <p v-html="
                $t(
                  'productos_list.productos.orientacion_profesional.description'
                )
              "></p>

            <router-link class="btn-rounded-blue" :to="
                `${$t('enlaces.servicios')}/${$t(
                  'enlaces.orientacion_profesional'
                )}`
              ">{{ $t("moreInfo") }}</router-link>
          </div>

          <img src="/static/img/productos/orientacion-profesional.jpg" alt="orientacion profesional" />
        </div>

        <div class="producto-desc row-between container" :active="active == 'tiempo'">
          <div class="texto">
            <h2 class="title" v-html="
                $t('productos_list.productos.plataforma_e_learning.title')
              "></h2>
            <p v-html="
                $t('productos_list.productos.plataforma_e_learning.description')
              "></p>

            <router-link class="btn-rounded-blue" :to="
                `${$t('enlaces.servicios')}/${$t(
                  'enlaces.plataforma_e_learning'
                )}`
              ">{{ $t("moreInfo") }}</router-link>
          </div>

          <img src="/static/img/productos/e-learning.jpg" alt="e-learning" />
        </div>

        <div class="producto-desc row-between container" :active="active == 'gestor'">
          <div class="texto">
            <h2 class="title" v-html="$t('productos_list.productos.gestor_de_formacion.title')"></h2>
            <p v-html="
                $t('productos_list.productos.gestor_de_formacion.description')
              "></p>

            <router-link class="btn-rounded-blue" :to="
                `${$t('enlaces.servicios')}/${$t(
                  'enlaces.gestor_de_formacion'
                )}`
              ">{{ $t("moreInfo") }}</router-link>
          </div>

          <img src="/static/img/productos/gestor-formacion.jpg" alt="gestor de formación" />
        </div>

        <div class="producto-desc row-between container" :active="active == 'crm'">
          <div class="texto">
            <h2 class="title" v-html="$t('productos_list.productos.crm_fundaciones.title')"></h2>
            <p v-html="
                $t('productos_list.productos.crm_fundaciones.description')
              "></p>

            <router-link class="btn-rounded-blue" :to="
                `${$t('enlaces.servicios')}/${$t('enlaces.crm_fundaciones')}`
              ">{{ $t("moreInfo") }}</router-link>
          </div>

          <img src="/static/img/productos/crm.jpg" alt="crm" />
        </div>

        <div class="producto-desc row-between container" :active="active == 'robot'">
          <div class="texto">
            <h2 class="title" v-html="$t('productos_list.productos.robot.title')"></h2>
            <p v-html="$t('productos_list.productos.robot.description')"></p>

            <router-link class="btn-rounded-blue" :to="`${$t('enlaces.servicios')}/${$t('enlaces.robot')}`">{{ $t("moreInfo") }}</router-link>
          </div>

          <img src="/static/img/productos/robot.jpg" alt="robot" />
        </div>
        <div class="producto-desc row-between container" :active="active == 'simuladores'">
          <div class="texto">
            <h2 class="title" v-html="$t('productos_list.productos.simuladores.title')"></h2>
            <p v-html="$t('productos_list.productos.simuladores.description')"></p>

            <router-link class="btn-rounded-blue" :to="`${$t('enlaces.servicios')}/${$t('enlaces.simuladores')}`">{{ $t("moreInfo") }}</router-link>
          </div>

          <img src="/static/img/productos/simuladores-prod.jpg" alt="simuladores" />
        </div>
      </div>
    </section>
  </section>
</template>

<script lang="js">

  import { mapGetters } from 'vuex';

  export default {
    name: 'productos-list',
    data() {
      return {
        active: 'gestor',
        gif: {
          orientacion: 'gif',
          firma: 'jpg',
          gestor: 'jpg',
          crm: 'jpg',
          robot: 'jpg',
          simuladores: 'jpg',
          empresa: 'jpg'
        }
      }
    },
    methods: {
      setActive: function (value) {
        this.active = value;
        $('body,html').animate({ scrollTop: $(".intro-software-gestion").offset().top - 220 }, 800);
      },
      togif: function (value) {
        this.gif[value] = "gif";
      },
      toJPG: function (value) {
        this.gif[value] = "jpg";
      }
    },
    computed: {
      ...mapGetters(['getTexts']),
      productos: function () {
        return this.getTexts.productos_list.productos;
      },
      isProduct: function () {
        return (this.$route.path.includes('servicios'));
      }
    }

  }
</script>

<style scoped>
  .productos-list-section {
    padding-top: 0px;
  }

  .productos-list {
    margin-bottom: 50px;
  }

  .casos-de-exito+.productos-list-section {
    padding-top: 100px;
  }

  h3 {
    font-size: 36px;
    line-height: 50px;
    color: #3374b0;
    font-weight: 300;
    width: 100%;
    display: inline-block;
    text-align: center;
  }

  .title {
    font-size: 36px;
    color: #3374b0;
    margin-bottom: 40px;
  }

  .title.-main {
    margin-bottom: 0;
  }

  .producto {
    width: 20%;
    text-align: center;
    display: -webkit-flex;
    display: -moz-flex;
    display: -ms-flex;
    display: -o-flex;
    display: flex;
    -webkit-flex-direction: column;
    -moz-flex-direction: column;
    -ms-flex-direction: column;
    -o-flex-direction: column;
    flex-direction: column;
    justify-content: space-between;
    -webkit-justify-content: space-between;
    -ms-align-items: center;
    align-items: center;
    padding-bottom: 20px;
    position: relative;
    overflow: hidden;
    cursor: pointer;
  }

  .producto::after {
    width: 100%;
    height: 2px;
    content: "";
    display: inline-block;
    position: absolute;
    left: 0;
    bottom: 2px;
    background: #cecece;
  }

  .producto::before {
    width: 80%;
    height: 5px;
    content: "";
    display: inline-block;
    position: absolute;
    left: 10%;
    bottom: 1px;
    background: red;
    z-index: 2;
    transform: translateY(10px);
    transition: 0.4s;
    animation-timing-function: ease-in-out;
  }

  .producto.orientacion::before {
    background: #41566d;
  }

  .producto.empresa::before {
    background: #df1517;
  }

  .producto.gestor::before {
    background: #51ac34;
  }

  .producto.crm::before {
    background: #3374b0;
  }

  .producto.simuladores::before {
    background: #1d1d1b;
  }

  .producto.orientacion:hover h4,
  .producto.orientacion[active="true"] h4 {
    color: #41566d;
  }

  .producto.empresa:hover h4,
  .producto.empresa[active="true"] h4 {
    color: #df1517;
  }

  .producto.gestor:hover h4,
  .producto.gestor[active="true"] h4 {
    color: #51ac34;
  }

  .producto.crm:hover h4,
  .producto.crm[active="true"] h4 {
    color: #3374b0;
  }

  .producto.simuladores:hover h4,
  .producto.simuladores[active="true"] h4 {
    color: #1d1d1b;
  }

  .producto:hover::before,
  .producto[active="true"]::before {
    transform: translateX(0);
  }

  .producto .contenedor-imagen {
    height: 220px;
    width: 100%;
    display: inline-block;
    padding: 30px;
  }

  .producto .contenedor-imagen img {
    max-width: 100%;
    max-height: 100%;
  }

  .producto h4 {
    max-width: 150px;
    width: 100%;
    color: #717171;
    font-size: 20px;
    font-weight: 800;
    text-align: center;
    font-family: "Ubuntu Mono";
    transition: 0.5s;
  }

  .intro-software-gestion {
    padding-bottom: 100px;
    overflow: hidden;
    position: relative;
  }

  .intro-software-gestion .box {
    position: relative;
    overflow: hidden;
    padding: 0;
    text-align: left;
  }

  .intro-software-gestion .producto-desc {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 2;
    transform: translateY(-101%);
    background: white;
    transition: 0.5s;
    width: 100%;
  }

  .intro-software-gestion .producto-desc:first-of-type {
    position: relative;
    left: auto;
    top: auto;
  }

  .intro-software-gestion .producto-desc[active="true"] {
    transform: translateY(0%);
  }

  .intro-software-gestion .texto {
    width: 50%;
    max-width: 530px;
    text-align: left;
    /* padding-left: 100px; */
  }

  .intro-software-gestion .title {
    color: #3374b0;
    margin-bottom: 20px;
    line-height: 1.2em;
  }

  .intro-software-gestion p {
    line-height: 28px;
    font-size: 16px;
    color: #41566d;
    margin-bottom: 10px;
    text-align: left;
    max-width: 450px;
  }

  .intro-software-gestion strong {
    font-weight: 600;
  }

  @media screen and (max-width: 1820px) {
    .producto .contenedor-imagen[data-v-56494384] {
      height: 186px;
    }
  }

  @media screen and (max-width: 1145px) {
    .intro-software-gestion .texto {
      width: 100%;
      max-width: 100%;
      text-align: left;
      padding: 0 20px;
      margin-bottom: 30px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }

    .intro-software-gestion p {
      max-width: 100%;
    }

    .box.container img {
      margin: 0 auto;
    }

    .producto .contenedor-imagen {
      height: auto;
    }
  }

  @media screen and (max-width: 600px) {
    .container.mvl {
      overflow: hidden;
    }

    .producto .contenedor-imagen {
      display: none;
    }

    .intro-software-gestion {
      padding-bottom: 200px;
    }
    .home .intro-software-gestion {
      padding-bottom: 20px;
    }
    .scroll-mvl {
      width: 100vw;
      overflow-x: scroll;
    }

    .producto h4 {
      font-size: 16px;
    }

    .productos-list {
      margin-bottom: 50px;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      width: 777px;
      padding-right: 30px;
    }

    .box.container img {
      width: 100%;
    }

    h3 {
      line-height: 24px;
      padding: 0 20px;
    }

    .intro-software-gestion .texto {
      padding: 0;
    }
  }

  @media screen and (max-width: 320px) {
    .productos-list {
      width: 655px;
    }

    h3 {
      padding: 0;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/parts/productos-list.vue